import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';

const state = () => ({
  feed: null,
  feedLoading: false,
  nextPostsLoading: false,
  error: null,

  activeNewsTab: 'general',

  headlines: null,
  headlinesLoading: false,
  headlinesError: null,

  trendingIndices: [],
  trendingIndicesError: null,
  trendingIndicesLoading: false,

  allTrendingIndices: null,
  allTrendingIndicesError: null,
  allTrendingIndicesLoading: false,

  keyFigures: null,
  keyFiguresError: null,
  keyFiguresLoading: false,

  deleteUserPost: { data: null, loading: false, error: null },
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
